import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const Body = styled.div``;

export const globalCss = css`
    body {
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-width: 32rem;
    }
`;
